function FTDefaultValues() {
    return {
      session_id: process.env.REACT_APP_API_SESSION_ID,
      originatorKYCLevel: "2",
      paymentReference: "5436018943",
      originatorAccountName: "John Doe",
      originatorAccountNumber: "8055577119",
      originatorBankVerificationNumber: "33333333339",
      transactionLocation: "6.4300747, 3.4110715",
      amount: "1000.00",
      narration: "Funds transfer from Tomiwa to Anita",
    };
  }

  export default FTDefaultValues;